import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** Sekce detailu v administraci: nadpis, volitelná akce a obsah. */
export const AdminSection = ({
  title,
  description,
  action,
  children,
  className,
}: {
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  children: ReactNode
  className?: string
}) => (
  <section className={cn('space-y-3', className)}>
    <div className="flex items-end justify-between gap-4">
      <div>
        <h2 className="text-base font-medium">{title}</h2>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
    {children}
  </section>
)
